import React from 'react';
import graph from './graph';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import { Stack, Avatar, Button, Typography, IconButton, CircularProgress } from '@mui/material';

export default function AssignAllProduct({ id, active, refetch }) {
  const [open, setOpen] = React.useState(false);
  const { userToken } = useSelector((state) => state.auth);
  const [assignment, { loading }] = useMutation(graph.assignment.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const onSubmit = async () => {
    try {
      const { data, errors } = await assignment({
        context: {
          serviceName: graph.assignment.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          coupon_id: id,
          assignment_type: 'ALL_PRODUCT',
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.assignment.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <Button
        fullWidth
        variant={active ? 'contained' : 'text'}
        sx={{ bgcolor: !active && 'primary.lighter' }}
        size="medium"
        color="primary"
        onClick={onOpen}
      >
        {loading ? <CircularProgress color="primary" size={25} /> : 'همه'}
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title="همه محصولات" onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack flex={1} rowGap={2} alignItems="center" justifyContent="center" bgcolor="background.paper">
            <Avatar
              variant="rounded"
              sx={{
                width: 120,
                height: 120,
                borderRadius: 4,
                bgcolor: 'action.hover',
              }}
              src="/assets/icons/glass/trash.svg"
            />
            <Typography variant="subtitle1" align='center'>آیا از اختصاص این بن به همه محصولات مطمئن هستید؟</Typography>
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button color="warning" variant="outlined" onClick={onClose}>
            <FormattedMessage id="ignore" />
          </Button>
          <Button
            autoFocus
            color="error"
            variant="contained"
            disabled={loading}
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : 'بله'}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
